import listQuery from './ReferencePrefixListQuery.graphql';
import instanceQuery from './ReferencePrefixQuery.graphql';
import mutationQuery from './ReferencePrefixMutation.graphql';
import bulkMutationQuery from './ReferencePrefixBulkMutation.graphql';
import fragment from './ReferencePrefixFragment.graphql';

const ReferencePrefix = {
  type: 'ReferencePrefix',
  title: 'Reference Prefix',
  instance: instanceQuery,
  update: mutationQuery,
  bulkUpdate: bulkMutationQuery,
  notificationKey: 'reference',
  listQuery,
  fragment,
};

export default ReferencePrefix;
